module.exports = __webpack_public_path__ + "static/media/dw_header.3c01893f.png";